"use strict";

module.exports = function (accumulator, order, product, component) {
  if (component.product_size.match(/20x30|24x36/)) {
    return 20;
  }

  return accumulator;
};